// a library to wrap and simplify api calls
import Api from './PhiApi'
import CONSTANTS from "./Constants";
import JSZip from 'jszip';

// import {getMetadata, metadataRuleSets} from 'page-metadata-parser'
// import {JSDOM} from "jsdom";


export default class PhiOrganization {

    constructor(options) {
        this.phiRef = options

        this.fetchOrganizationList = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let roleId = that.phiRef.User.roles()[0].role_type_id
                config.orgActive = CONSTANTS.roles[roleId].orgActive[config.orgType]
                let response = yield Api.fetchOrganizationList(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.fetchQCList = function* (that, config) {
            let token = that.phiRef.getSession()
            if(Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchQCList(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.fetchQCDetail = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchQCDetail(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.editQCRemarks = function *(that, config, metricId) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.editQCRemarks(config, metricId)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.getGlossary = function* (that) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getGlossary();
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.fetchStudentList = function* (that, payload) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchStudentList(payload);
                //console.log("fetchStudentList: ", response)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            } else {
                return { error: 'authentication error' }
            }
        }

        this.fetchStudentDataOMR = function* (that, id) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchStudentDataOMR({ startNode: id });

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200 && response.data.results.length) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.getOrganization = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getOrganization(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    const organization = JSON.parse(response.data.results[0].org)
                    return organization && organization.length ? organization[0] : {}
                } else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.addOrganization = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.addOrganization({ orgJson: JSON.stringify([config]) })
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.editOrganization = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.editOrganization(config.organizationId, { orgJson: JSON.stringify([config.organizationData]), "changeDesc": "Edit test", "userid": 1 })
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.getContentNode = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getContentNode(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.addContentNode = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.addContentNode(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.editContentNode = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.editContentNode(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }



        this.getContentAssociation = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getContentAssociation(config)
                if (response.ok && response.data && response.data.results) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.addContentAssociation = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.addContentAssociation(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.editContentAssociation = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.editContentAssociation(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.fetchMetricManifest = function* (that) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchMetricManifest();

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200 && response.data.results.length) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.fetchStudentAssessmentDetails = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchStudentAssessmentDetails({urlParam: config.schoolId, headerParam: {studentId: config.studentId}});

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200 && response.data.results.length) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.updateStudentAssessmentDetails = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.updateStudentAssessmentDetails({ urlParam: config.id, 
                    payload: {
                        changeUserId: config.userId,
                        metricCustomJson: JSON.stringify({ data: config.data })
                    }});

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200 && response.data.results.length) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.fetchStudentAssessmentHistory = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchStudentAssessmentHistory({studentId: config.userId});

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200 && response.data.results.length) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.fetchStudentAssessmentStatus = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchStudentAssessmentStatus({studentId: config.userId, inEventTrackId: config.eventTrackId});

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data returned' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.fetchDMFTIndex = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchDMFTIndex({studentId: config.studentId, inEventTrackId: config.startNodeId});

                if(!response.ok) {
                    return { error: response.problem }
                }
                else if (response.data && response.data.status === 200) {
                    return response.data.results;
                }
                else {
                    return { error: 'Invalid data returned' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }

        this.fetchPentahoReport = function* (that, config, isPdf) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = null;

                if(!Boolean(isPdf)) {
                    response = yield Api.fetchPentahoReport(config);
                }
                else {
                    response = yield Api.fetchPentahoReportPDF(config);
                }

                if (Boolean(response) && response.ok && response.data && response.data.output) {
                    
                    if(Boolean(isPdf)) {
                        const base64str = response.data.output;

                        // decode base64 string, remove space for IE compatibility
                        var binary = atob(base64str.replace(/\s/g, ''));
                        var len = binary.length;
                        var buffer = new ArrayBuffer(len);
                        var view = new Uint8Array(buffer);
                        for (var i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }

                        // create the blob object with content-type "application/pdf"               
                        var blob = new Blob( [view], { type: "application/pdf" });

                        return { data: blob };
                    }

                    let htmlContent, styleContent, cssFileName, reportHeaderstyle = ''
                    let base64 = response.data.output
                    let zipFile = new JSZip()
                    let content = yield zipFile.loadAsync(base64, {base64: true})
                    if (content && content.files) {
                        let files = content.files
                        let fileData = null

                        for (let key in files) {
                            let obj = files[key]
                            if (key.endsWith(".css")) {
                                fileData = yield obj.async("string")
                                styleContent = fileData
                                cssFileName = key    
                            }
                            else if (key.endsWith(".zip") || key.endsWith(".htm")) {
                                fileData = yield obj.async("string")
                                htmlContent = fileData
                            }                                                  
                        }      

                        for(let file in files) {
                            let imageBase64 = null
                            let obj = files[file]

                            if(file.endsWith(".png")) {
                                imageBase64 =  yield obj.async("base64")
                                htmlContent = htmlContent.split(file).join(`data:image/png;base64, ${imageBase64}`)                
                            }

                        } 

                        styleContent += '.frame-content >  table { width: 100%; height: 100%; }';
                        //retaining the styles coming in the reports
                        if (htmlContent.indexOf('<style type="text/css">')) {
                            reportHeaderstyle = htmlContent.substring(htmlContent.indexOf('<style type="text/css">'), htmlContent.indexOf('</head>'))
                            reportHeaderstyle = reportHeaderstyle.replace('<style type="text/css">', '')
                            reportHeaderstyle = reportHeaderstyle.replace('</style>', '')
                            styleContent += reportHeaderstyle
                        }

                        htmlContent = htmlContent.substr(htmlContent.indexOf('<body>'),htmlContent.length).replace(/\n+/g,'').replace(/\>\s+\</g,'><')
                        htmlContent = htmlContent.replace('</body></html>', "").replace(`<body>`, `<style>${styleContent}</style>`)
                     // htmlContent += '<link type="text/css" rel="stylesheet" href="./Reports.css" />'
                        
                        return { data: htmlContent };
                    }
                }
                else {
                    return { error: response.problem || 'Unable to fetch the report' }
                }
            }
            else {
                return { error: 'authentication error' }
            }
        }


        this.postExpertQueries = function* (that, queryData) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postExpertQueries(JSON.stringify({ queryData: JSON.stringify(queryData) }));

                if(!response.ok) {
                    return { ok: false, error: response.problem }
                }
                else if (response.data && response.data.status === 200) {
                    return {ok: true};
                }
                else {
                    return { ok: false, error: 'Failed to submit query' }
                }
            }
            else {
                return { ok: false, error: 'authentication error' }
            }
        }


        this.postAppointmentRequest = function* (that, appointmentData) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postRequestAppointment(JSON.stringify({ appointmentData: JSON.stringify(appointmentData) }));

                if(!response.ok) {
                    return { ok: false, error: response.problem }
                }
                else if (response.data && response.data.status === 200) {
                    return {ok: true};
                }
                else {
                    return { ok: false, error: 'Failed to submit appointment request' }
                }
            }
            else {
                return { ok: false, error: 'authentication error' }
            }
        }


        this.getVaccination = function* (that) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getVaccination();

                if(!response.ok) {
                    return { ok: false, error: response.problem }
                }
                else if (response.data && response.data.status === 200) {
                    return {ok: true, data: response.data};
                }
                else {
                    return { ok: false, error: 'Failed to submit appointment request' }
                }
            }
            else {
                return { ok: false, error: 'authentication error' }
            }
        }




        this.getS3Credentials = function* (that, config={}) {

            let response = yield Api.getS3Creds(config)

            if (response && response.ok && response.status === 200) {
                return response.data
            } else {
                return false
            }
        }

        this.getContentAssociation = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getContentAssociation(config)
                if (response.ok && response.data && response.data.results) {
                    return response.data.results
                }
                else {
                    return { error: response.problem }
                }
            }
            return null
        }

        this.uploadToS3 = function* (file, s3CredsData, schoolContentID) {

            let form = new FormData();
            let key
            const options = {
                enctype: "multipart/form-data",
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            key = s3CredsData.conditions[7][2] + `${schoolContentID}/` + (file.name).replace(/.*[\/\\]/, '')
            form.append('bucket', s3CredsData.conditions[0].bucket)
            form.append('key', key)
            form.append('acl', s3CredsData.conditions[1]['acl'])
            form.append('Content-Type', file.type)
            form.append('x-amz-meta-uuid', s3CredsData.conditions[5]['x-amz-meta-uuid'])
            form.append('x-amz-server-side-encryption', s3CredsData.conditions[6]['x-amz-server-side-encryption'])
            form.append('X-Amz-Credential', s3CredsData.conditions[2]['x-amz-credential'])
            form.append('X-Amz-Algorithm', s3CredsData.conditions[3]['x-amz-algorithm'])
            form.append('X-Amz-Date', s3CredsData.conditions[4]['x-amz-date'])
            form.append('x-amz-meta-tag', s3CredsData.conditions[9][2])
            form.append('Policy', s3CredsData.policy)
            form.append('X-Amz-Signature', s3CredsData.signature)
            form.append('file', file)

            let response = yield Api.uploadToS3(form, options)
            return response
        }

        this.getMetaData = function* (that, options) {
            const { metaType, config } = options
            let response, headerconfig
            
            let token = that.phiRef.getSession()
            if (token) {
                const metaDataMap = {
                    'city': (config) => Api.getCity(config || {stateId: 2}),
                    'district': (config) => Api.getDistrict(config || {}),
                    'state': (config) => Api.getStates(config || {countryId: CONSTANTS.defaultRegionCodes.INDIA_COUNTRY_CODE}),
                    'country': (config) => Api.getCountry(config || {})
        
                }
                const response = yield metaDataMap[metaType](config)
                // console.log('Response', response)
                if (response && response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    let metadata = response.data.results
                    return metadata.map((a) => a)
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.getCovidGlobalDashboardInd = function* (that, payload) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getCovidGlobalDashboardInd(payload)
                
                if (response.ok && response.data ) {
                    return response.data
                } else {
                    return { error: response.problem }
                }
            } else {
                return { error: 'Stats not available' }
            }
        }

        this.getCovidGoogleRSSFeed = function* (that, payload) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getCovidGoogleRSSFeed(payload.limit, payload.start)
                
                if (response.ok && response.data ) {
                    return response.data
                } else {
                    return { error: response.problem }
                }
            } else {
                return { error: 'Stats not available' }
            }
        }

        this.getCovidDeclarationOverallSymptomsV2 = function* (that, payload) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getCovidDeclarationOverallSymptomsV2(payload)
                
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            } else {
                return { error: 'Stats not available' }
            }
        }

        this.addUserCommunityIfDoesNotExist = function* (that, params) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.addUserCommunityIfDoesNotExist(params)
                
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            } else {
                return { error: 'Stats not available' }
            }
        }

        this.getOpenAPI = function* (that, url) {
            // let response = yield Api.getOpenAPI(url.link)

            // if (response && response.data) {
                // let doc = JSDOM.fragment(response.data)
                // let metadata = getMetadata(doc, url.link, {image: metadataRuleSets.image})

                // return  { [url.index]: metadata.image }
            // }

            // return  { [url.index]: null }

        }

    }



}